import SimpleList from '@/components/common/simple-list';
import TenantLogo from '@/components/common/tenant-logo';
import { getFooterSocialItems } from '@/components/layout/footer/footer-social/footer-social-items';
import { useTenant } from '@/providers/TenantProvider';

const FooterSocial = () => {
  const {
    tenantConfig: { settings },
  } = useTenant();

  if (settings.socialLinks.length === 0) {
    return null;
  }

  const data = getFooterSocialItems(settings);

  return (
    <section className="my-4 flex w-full items-center justify-between">
      <div className="flex w-full items-center justify-start">
        <TenantLogo className="max-w-24" />
      </div>
      <div className="flex w-full items-center justify-end">
        {data.map((item) => (
          <SimpleList
            key={item.id}
            data={item}
          />
        ))}
      </div>
    </section>
  );
};

export default FooterSocial;
